<script>
import Banner from 'dashboard/components/ui/Banner.vue';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { LocalStorage } from 'shared/helpers/localStorage';
import { mapGetters } from 'vuex';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useFandataPerfil } from 'dashboard/composables/useFandataPerfil';
import { hasAnUpdateAvailable } from './versionCheckHelper';

// O AVISO DE NOVA VERSÃO SAI DA TELA DO CLUBE (14/10).
//
// Ele apareceu num print que a equipe mandou: "Uma atualização 4.57.0 para o FanData está
// disponível. Por favor, atualize sua instância."
//
// O T-278 já tinha restringido o aviso ao administrador, e a pergunta certa não era QUEM vê, era
// se alguém do lado deles deveria ver. Não deveria, por três motivos:
//
//   · atualizar a plataforma é nosso, não deles. O aviso pede uma ação que ninguém ali pode
//     tomar, e cobra sobre algo que já é nossa responsabilidade;
//   · o link leva ao repositório do projeto de origem, que não é a nossa entrega e não faz
//     sentido na tela de quem atende torcedor;
//   · a versão que ele compara é a do projeto de origem, não a nossa. Este fork anda por conta
//     própria, então "está desatualizado" nem é verdade aqui.
//
// Fica como constante, e não apagado, porque o mecanismo serve PARA NÓS no dia em que existir o
// perfil Desenvolvedor (T-264): aí é trocar isto por aquele perfil, e quem sustenta a plataforma
// volta a ser avisado. Apagar custaria o mesmo e perderia o caminho de volta.
const MOSTRAR_AVISO_DE_VERSAO = false;

export default {
  components: { Banner },
  props: {
    latestChatwootVersion: { type: String, default: '' },
  },
  setup() {
    const { isAdmin } = useAdmin();
    // T-278: quem vê o aviso de atualização é o Administrador e o Desenvolvedor, decisão do
    // Douglas em 25/09. Atualizar a plataforma é decisão de quem a sustenta; para quem atende,
    // aquilo é só um botão perigoso no caminho, e a Tamara pediu justamente para o agente não
    // clicar sem querer.
    //
    // O `isAdmin` do Chatwoot sozinho não bastava: é o PAPEL, e um backoffice ou uma curadoria de
    // IA podem ter papel de administrador sem serem o administrador da operação. Quem decide aqui
    // é o PERFIL FanData. O perfil Desenvolvedor ainda não existe (T-264); quando existir, é só
    // acrescentar ao `ehAdmin` desta linha.
    const { ehAdmin } = useFandataPerfil();
    return {
      isAdmin,
      ehAdmin,
    };
  },
  data() {
    return { userDismissedBanner: false };
  },
  computed: {
    ...mapGetters({ globalConfig: 'globalConfig/get' }),
    updateAvailable() {
      return hasAnUpdateAvailable(
        this.latestChatwootVersion,
        this.globalConfig.appVersion
      );
    },
    bannerMessage() {
      return this.$t('GENERAL_SETTINGS.UPDATE_CHATWOOT', {
        latestChatwootVersion: this.latestChatwootVersion,
      });
    },
    shouldShowBanner() {
      if (!MOSTRAR_AVISO_DE_VERSAO) return false;

      return (
        !this.userDismissedBanner &&
        this.globalConfig.displayManifest &&
        this.updateAvailable &&
        !this.isVersionNotificationDismissed(this.latestChatwootVersion) &&
        this.isAdmin &&
        this.ehAdmin
      );
    },
  },
  methods: {
    isVersionNotificationDismissed(version) {
      const dismissedVersions =
        LocalStorage.get(LOCAL_STORAGE_KEYS.DISMISSED_UPDATES) || [];
      return dismissedVersions.includes(version);
    },
    dismissUpdateBanner() {
      let updatedDismissedItems =
        LocalStorage.get(LOCAL_STORAGE_KEYS.DISMISSED_UPDATES) || [];
      if (updatedDismissedItems instanceof Array) {
        updatedDismissedItems.push(this.latestChatwootVersion);
      } else {
        updatedDismissedItems = [this.latestChatwootVersion];
      }
      LocalStorage.set(
        LOCAL_STORAGE_KEYS.DISMISSED_UPDATES,
        updatedDismissedItems
      );
      this.userDismissedBanner = true;
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Banner
    v-if="shouldShowBanner"
    color-scheme="primary"
    :banner-message="bannerMessage"
    href-link="https://github.com/chatwoot/chatwoot/releases"
    :href-link-text="$t('GENERAL_SETTINGS.LEARN_MORE')"
    has-close-button
    @close="dismissUpdateBanner"
  />
</template>
